module.exports = __webpack_public_path__ + "static/media/Pokemon.9fd105f5.png";